import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';

@Component({
  selector: 'app-inventory-table-search',
  standalone: true,
  imports: [MatFormFieldModule, MatIconModule, MatInputModule, FormsModule, IconComponent],
  templateUrl: './inventory-table-search.component.html',
  styleUrl: './inventory-table-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InventoryTableSearchComponent {
  public readonly searchTerm = signal('');
  public readonly placeholder = input('');
  public readonly searchInput = output<string>();
  public readonly iconName = IconName;

  public onInputChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm.set(value);
    this.searchInput.emit(this.searchTerm());
  }
}
